.background {
  background-position: center;
  background-size: inherit;
  background-repeat: no-repeat;
}
